import {ValueType} from '@/api/meta/filters';
import {ApiSortOrder, ApiSortsDerived} from '@/api/meta/odata';
import {getProviders} from '@/api/module/provider';
import Provider, {ApiProvider, ProviderFilters, ProviderStatus} from '@/model/Provider';
import {createVersionedStorage} from './types';
import {boolToDisplay, fulltextToDisplay, toDisplay} from '@/util/store';

// const filterNames: Record<keyof ProviderFilters, string | null> = {
//   'Fulltext$Fulltext': 'Suche',
//   'KundStatus$In': null,
//   'KundenNr': 'Kunden-Nr.',
//   'Kundname': 'Kundenname',
//   'LieferantErledigt': 'Lieferant erledigt',
// };

export const providerStatusFilterData = {
  [ProviderStatus.Interessenten]: {
    color: 'warning',
    value: 'Interessent',
  },
  [ProviderStatus.EhemaligeKunden]: {
    color: 'error',
    value: 'Ehemalige Kunden',
  },
  [ProviderStatus.Kunden]: {
    color: 'success',
    value: 'Kunden',
  },
  [ProviderStatus.Lieferanten]: {
    color: 'primary',
    value: 'Lieferanten',
  },
  [ProviderStatus.InteressentErledigt]: {
    color: '#840000',
    value: 'erl. Interessent',
  },
} as const;

const useProvidersStore = createVersionedStorage<
  ProviderFilters,
  ApiSortsDerived<ApiProvider>,
  Provider[]
>('providers', {
  fetchFn: getProviders,
  formatter: {
    Fulltext$Fulltext: fulltextToDisplay,
    KundenNr: toDisplay('Kunden-Nr.'),
    Kundname: toDisplay('Kundenname'),
    LieferantErledigt: boolToDisplay('Ja', 'Nein', 'Lieferant erledigt'),
    KundStatus$In(value) {
      if (value) {
        return value.map((val, indx) => ({
          color: providerStatusFilterData[val].color,
          text: providerStatusFilterData[val].value,
          keypath: [indx.toString()],
        }));
      }
    },
  },
  // convertFilterToDisplayFn: createConvertFiltersToDisplayFn(
  //     createGetRowFn({
  //       getLabel: ({actualKeys}) => filterNames[actualKeys[0] as keyof ProviderFilters],
  //       getColor: ({actualKeys, value}) => actualKeys[0] === 'KundStatus$In' ? providerStatusFilterData[value as ProviderStatus].color : undefined,
  //       getValue: ({actualKeys, value}) => actualKeys[0] === 'KundStatus$In' ? providerStatusFilterData[value as ProviderStatus].value : undefined,
  //     }),
  // ),
  defaultData: [],
  defaultFilters: {
    KundStatus$In: [ProviderStatus.EhemaligeKunden, ProviderStatus.Interessenten, ProviderStatus.Kunden, ProviderStatus.InteressentErledigt],
    Fulltext$Fulltext: {words: [], fields: [
      {
        path: ['Kundname'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['KundenNr'],
        valueType: ValueType.Naked,
      },
      {
        path: ['Disponent'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['VertriebsBeauftragter'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['VertriebsBeauftragter2'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['PostAnschrift', 'Plz'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['PostAnschrift', 'Ort'],
        valueType: ValueType.StringContains,
      },
    ]},
  },
  defaultSorts: [['Kundname', ApiSortOrder.Asc]],
  defaultLimit: 10,
});

export default useProvidersStore;
